import { FlexBox } from '../common/boxes';
import { Loader } from '../common/Loader';
import { Box, Typography } from '@mui/material';
import { Person } from '@mui/icons-material';
import { useGetCustomerInfo } from '../../queryHooks/customer/useGetCustomerInfo';

const CustomerInfo = ({ customerId }: { customerId: number }) => {
  const { isFetching, data: customer } = useGetCustomerInfo({ customerId });
  return (
    <>
      {
        isFetching && <Box position={'relative'}><Loader width={50}/></Box>
      }
      {
        customer &&
        <FlexBox flexDirection={{ mobile: 'column', tablet: 'row' }} flexWrap={'wrap'}>
          <Person color={'primary'} sx={{ mr: 2 }}/>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Email:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {customer.email}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Login Type:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {customer.loginType}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Status:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {customer.status}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Type:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {customer.type}
            </Typography>
          </FlexBox>

          <FlexBox alignItems={'center'} sx={{ mr: { mobile: 0, tablet: 2 } }}>
            <Typography>
              {'Country:'}
            </Typography>
            <Typography variant={'body2'} sx={{ ml: 1 }}>
              {customer.country}
            </Typography>
          </FlexBox>

        </FlexBox>
      }
    </>
  );
};

export default CustomerInfo;